import React, { createContext, useState } from "react";
import {
  ClientContextType,
  DefaultClientContextType,
  IClientContext
} from "./ClientContextTypes";

export const ClientContext = createContext<ClientContextType>(
  DefaultClientContextType
);

export const DEFAULT_CLIENT = {
  client: {
    id: -1,
    name: "",
    email: "",
    phone: "",
    label: "",
    logo_path: "",
    base_color: "",
    kpi_label: "",
    currency: "",
    ui_modules: [],
    mmm_model_config: {
      metrics: []
    }
  },
  model: {
    id: -1,
    client_id: -1,
    name: "",
    year: -1,
    aggregation_type: "weekly"
  }
};

const getClientFromLocal = () => {
  const clientStored = localStorage.getItem("client");
  return clientStored ? JSON.parse(clientStored) : DEFAULT_CLIENT;
};

const ClientProvider: React.FC<{ children: React.ReactNode }> = ({
  children
}) => {
  const [currentClient, setCurrentClient] = useState<IClientContext>({
    ...getClientFromLocal()
  });

  const saveCurrentClient = (client: IClientContext) => {
    localStorage.setItem("client", JSON.stringify(client));
    setCurrentClient({ ...client });
  };

  return (
    <ClientContext.Provider value={{ currentClient, saveCurrentClient }}>
      {children}
    </ClientContext.Provider>
  );
};

export default ClientProvider;
